<template>
  <v-hover v-slot="{ hover }">
    <v-card :elevation="hover ? 6 : 2">
      <v-card-text>
        <v-row>
          <v-col cols="auto">
            <div class="text-left text-h5 font-weight-bold black--text"> <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>Energy distribution by time</div>
            <div class="text-left text-subtitle-1">ปริมาณการใช้ไฟฟ้าตามช่วงเวลา
             
            </div>
            <div class="text-left text-subtitle-1">
              <v-icon>mdi-sigma</v-icon>
            <template v-for="(item,index) in meter">
                <v-icon>mdi-gauge</v-icon>{{ item.assetName }} {{ index < meter.length - 1 ? '+' : '' }}
              </template>
            </div>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
           เลือกช่วงเวลา <DateRangePicker class="ml-2" v-model="range"/>
          </v-col>
            <v-col cols="auto"> <v-btn color="primary" :disabled="loading" @click="getEnergy()">View</v-btn></v-col>
        </v-row>
        <div ref="chart" style="width: 100%;height:350px;"></div>
      </v-card-text>
    </v-card>
  </v-hover> 
</template>
<script>
import * as echarts from 'echarts/core';
import {
  TooltipComponent,
  GridComponent,
  VisualMapComponent
} from 'echarts/components';
import { HeatmapChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import * as alasql from 'alasql'
import DateRangePicker from '@/components/common/DateRangePicker.vue'

echarts.use([
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  HeatmapChart,
  CanvasRenderer
]);

// prettier-ignore
const hours = [
  '12a', '1a', '2a', '3a', '4a', '5a', '6a',
  '7a', '8a', '9a', '10a', '11a',
  '12p', '1p', '2p', '3p', '4p', '5p',
  '6p', '7p', '8p', '9p', '10p', '11p'
];
// prettier-ignore
const days = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];

const dataKWH = [[0, 0, 5], [0, 1, 1], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [0, 8, 0], [0, 9, 0], [0, 10, 0], [0, 11, 2], [0, 12, 4], [0, 13, 1], [0, 14, 1], [0, 15, 3], [0, 16, 4], [0, 17, 6], [0, 18, 4], [0, 19, 4], [0, 20, 3], [0, 21, 3], [0, 22, 2], [0, 23, 5], [1, 0, 7], [1, 1, 0], [1, 2, 0], [1, 3, 0], [1, 4, 0], [1, 5, 0], [1, 6, 0], [1, 7, 0], [1, 8, 0], [1, 9, 0], [1, 10, 5], [1, 11, 2], [1, 12, 2], [1, 13, 6], [1, 14, 9], [1, 15, 11], [1, 16, 6], [1, 17, 7], [1, 18, 8], [1, 19, 12], [1, 20, 5], [1, 21, 5], [1, 22, 7], [1, 23, 2], [2, 0, 1], [2, 1, 1], [2, 2, 0], [2, 3, 0], [2, 4, 0], [2, 5, 0], [2, 6, 0], [2, 7, 0], [2, 8, 0], [2, 9, 0], [2, 10, 3], [2, 11, 2], [2, 12, 1], [2, 13, 9], [2, 14, 8], [2, 15, 10], [2, 16, 6], [2, 17, 5], [2, 18, 5], [2, 19, 5], [2, 20, 7], [2, 21, 4], [2, 22, 2], [2, 23, 4], [3, 0, 7], [3, 1, 3], [3, 2, 0], [3, 3, 0], [3, 4, 0], [3, 5, 0], [3, 6, 0], [3, 7, 0], [3, 8, 1], [3, 9, 0], [3, 10, 5], [3, 11, 4], [3, 12, 7], [3, 13, 14], [3, 14, 13], [3, 15, 12], [3, 16, 9], [3, 17, 5], [3, 18, 5], [3, 19, 10], [3, 20, 6], [3, 21, 4], [3, 22, 4], [3, 23, 1], [4, 0, 1], [4, 1, 3], [4, 2, 0], [4, 3, 0], [4, 4, 0], [4, 5, 1], [4, 6, 0], [4, 7, 0], [4, 8, 0], [4, 9, 2], [4, 10, 4], [4, 11, 4], [4, 12, 2], [4, 13, 4], [4, 14, 4], [4, 15, 14], [4, 16, 12], [4, 17, 1], [4, 18, 8], [4, 19, 5], [4, 20, 3], [4, 21, 7], [4, 22, 3], [4, 23, 0], [5, 0, 2], [5, 1, 1], [5, 2, 0], [5, 3, 3], [5, 4, 0], [5, 5, 0], [5, 6, 0], [5, 7, 0], [5, 8, 2], [5, 9, 0], [5, 10, 4], [5, 11, 1], [5, 12, 5], [5, 13, 10], [5, 14, 5], [5, 15, 7], [5, 16, 11], [5, 17, 6], [5, 18, 0], [5, 19, 5], [5, 20, 3], [5, 21, 4], [5, 22, 2], [5, 23, 0], [6, 0, 1], [6, 1, 0], [6, 2, 0], [6, 3, 0], [6, 4, 0], [6, 5, 0], [6, 6, 0], [6, 7, 0], [6, 8, 0], [6, 9, 0], [6, 10, 1], [6, 11, 0], [6, 12, 2], [6, 13, 1], [6, 14, 3], [6, 15, 4], [6, 16, 0], [6, 17, 0], [6, 18, 0], [6, 19, 0], [6, 20, 1], [6, 21, 2], [6, 22, 2], [6, 23, 6]]
  .map(function (item) {
    return [item[1], item[0], item[2] || '-'];
  });


const dataPrice = [[0, 0, 40], [0, 1, 8], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [0, 8, 0], [0, 9, 0], [0, 10, 0], [0, 11, 16], [0, 12, 32], [0, 13, 8], [0, 14, 8], [0, 15, 24], [0, 16, 32], [0, 17, 48], [0, 18, 32], [0, 19, 32], [0, 20, 24], [0, 21, 24], [0, 22, 16], [0, 23, 40], [1, 0, 56], [1, 1, 0], [1, 2, 0], [1, 3, 0], [1, 4, 0], [1, 5, 0], [1, 6, 0], [1, 7, 0], [1, 8, 0], [1, 9, 0], [1, 10, 40], [1, 11, 16], [1, 12, 16], [1, 13, 48], [1, 14, 72], [1, 15, 88], [1, 16, 48], [1, 17, 56], [1, 18, 64], [1, 19, 96], [1, 20, 40], [1, 21, 40], [1, 22, 56], [1, 23, 16], [2, 0, 8], [2, 1, 8], [2, 2, 0], [2, 3, 0], [2, 4, 0], [2, 5, 0], [2, 6, 0], [2, 7, 0], [2, 8, 0], [2, 9, 0], [2, 10, 24], [2, 11, 26], [2, 12, 8], [2, 13, 72], [2, 14, 64], [2, 15, 80], [2, 16, 48], [2, 17, 40], [2, 18, 40], [2, 19, 40], [2, 20, 56], [2, 21, 32], [2, 22, 16], [2, 23, 32], [3, 0, 56], [3, 1, 24], [3, 2, 0], [3, 3, 0], [3, 4, 0], [3, 5, 0], [3, 6, 0], [3, 7, 0], [3, 8, 8], [3, 9, 0], [3, 10, 40], [3, 11, 32], [3, 12, 56], [3, 13, 14], [3, 14, 13], [3, 15, 12], [3, 16, 9], [3, 17, 5], [3, 18, 5], [3, 19, 10], [3, 20, 6], [3, 21, 4], [3, 22, 4], [3, 23, 1], [4, 0, 1], [4, 1, 3], [4, 2, 0], [4, 3, 0], [4, 4, 0], [4, 5, 1], [4, 6, 0], [4, 7, 0], [4, 8, 0], [4, 9, 2], [4, 10, 4], [4, 11, 4], [4, 12, 2], [4, 13, 4], [4, 14, 4], [4, 15, 14], [4, 16, 12], [4, 17, 1], [4, 18, 8], [4, 19, 5], [4, 20, 3], [4, 21, 7], [4, 22, 3], [4, 23, 0], [5, 0, 2], [5, 1, 1], [5, 2, 0], [5, 3, 3], [5, 4, 0], [5, 5, 0], [5, 6, 0], [5, 7, 0], [5, 8, 2], [5, 9, 0], [5, 10, 4], [5, 11, 1], [5, 12, 5], [5, 13, 10], [5, 14, 5], [5, 15, 7], [5, 16, 11], [5, 17, 6], [5, 18, 0], [5, 19, 5], [5, 20, 3], [5, 21, 4], [5, 22, 2], [5, 23, 0], [6, 0, 1], [6, 1, 0], [6, 2, 0], [6, 3, 0], [6, 4, 0], [6, 5, 0], [6, 6, 0], [6, 7, 0], [6, 8, 0], [6, 9, 0], [6, 10, 1], [6, 11, 0], [6, 12, 2], [6, 13, 1], [6, 14, 3], [6, 15, 4], [6, 16, 0], [6, 17, 0], [6, 18, 0], [6, 19, 0], [6, 20, 1], [6, 21, 2], [6, 22, 2], [6, 23, 6]]
  .map(function (item) {
    return [item[1], item[0], item[2] || '-'];
  });


export default {
  components: {
    DateRangePicker,
  },
  props: {
    meter: {
      type: Array
    }, 
    update: {
      type: Boolean
    }
  },
  computed: {
    building: {
      get: function () {
        return this.$store.state.User.building
      },
      set: function (newValue) {
        this.$store.dispatch('User/SET_BUILDING', newValue)
      }
    },
    hourlyEnergy: {
      get: function () {
        return this.$store.state.Energy.hourlyEnergy.map(a => [Number(a.weekDay), Number(a.H), Number(a.Unit)]).map(function (item) {
          return [item[1], item[0], item[2].toFixed(1) || '-'];
        })
      },
    },
  },
  methods: {
    getEnergy() {
      if (this.meter.length > 0) {
        const hourly = new Promise((resolve, reject) => {
        this.$store.dispatch('Energy/GET_HOURLY_ENERGY', { BuildingId: this.building.BuildingId, type: 'hourly', assetId: this.meter.map(a=> a.assetId), start: this.range.startDate.getTime(), end: this.range.endDate.getTime(), group: true}).then(() => {
          resolve()
        }).catch(() => { reject() })
      });
     
      this.loading = true
      this.myChart.setOption(this.option);
      Promise.all([hourly]).then(() => {
        this.loading = false
        let maxValue = alasql(`select Max(Unit) as max from ?`,[this.$store.state.Energy.hourlyEnergy])
        let minValue = alasql(`select Min(Unit) as min from ?`,[this.$store.state.Energy.hourlyEnergy])
        this.myChart.setOption({
          visualMap: {
          min: minValue[0].min,
          max: maxValue[0].max,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '15%'
        },
          series: [
            {
              name: 'kWh',
              data: this.hourlyEnergy
            }
          ]
        });
      }).catch(() => {
        this.loading = false
      })
    }else{
      this.myChart.setOption({
        series: [
            {
              name: 'kWh',
              data: []
            }
          ]
      })
    }
      }
      
  },
  watch: {
    update() {
            setTimeout(() => {
            this.myChart.resize()
            }, 80);
    },
    meter(value) {
      if (value && value.length > 0) {
          this.getEnergy()
        } else {
          this.loading = true
        }
    },
    toggle_exclusive(value) {
      // if (!value) {
      //   this.myChart.setOption({
      //     series: [
      //       {
      //         name: 'kWh',
      //         data: dataKWH
      //       }
      //     ]
      //   });
      // } else {
      //   this.myChart.setOption({
      //     series: [
      //       {
      //         name: 'Baht',
      //         data: dataPrice
      //       }
      //     ]
      //   });
      // }
    },
    selectedFloor(value) {
      let data = []
      value.forEach(element => {
        data.push({ name: element.name, value: (!this.toggle_exclusive) ? element.unit : (element.price * element.factor) })
      });
      this.myChart.setOption(
        {
          visualMap: {
          min: 0,
          max: 300,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '15%'
        },
          series: [
            {
              name: (!this.toggle_exclusive) ? 'Energy distribution (kWh)' : 'Energy distribution (Price)',
              data: data
            }
          ]
        }
      );
    }
  },
  data() {
    return {
      loading: true,
      myChart: null,
      toggle_exclusive: 0,
      toggle_loadType: 0,
      range: {
         startDate: this.$dayjs().subtract(14, 'day').toDate(),
         endDate: this.$dayjs().toDate(),
      },
      selectedFloor: [
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 1', unit: 1000, price: 7000, factor: 0.89 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 2', unit: 1440, price: 10080, factor: 0.97 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 3', unit: 2390, price: 16730, factor: 0.99 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 4', unit: 1203, price: 8521, factor: 0.98 },
      ],
      consumption: [
        { header: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี' },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 1', unit: 1000, price: 7000, factor: 0.89 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 2', unit: 1440, price: 10080, factor: 0.97 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 3', unit: 2390, price: 16730, factor: 0.99 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 4', unit: 1203, price: 8521, factor: 0.98 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 5', unit: 493, price: 3451, factor: 0.89 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 6', unit: 1345, price: 9415, factor: 0.93 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 7', unit: 1345, price: 9415, factor: 0.94 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 8', unit: 1345, price: 9415, factor: 0.95 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 9', unit: 1345, price: 9415, factor: 0.96 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 10', unit: 1345, price: 9415, factor: 0.97 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 11', unit: 1345, price: 9415, factor: 0.99 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 12', unit: 1000, price: 7000, factor: 0.89 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 13', unit: 1440, price: 10080, factor: 0.97 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 14', unit: 2390, price: 16730, factor: 0.99 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 15', unit: 1203, price: 8521, factor: 0.98 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 16', unit: 493, price: 3451, factor: 0.89 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 17', unit: 1345, price: 9415, factor: 0.93 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 18', unit: 1345, price: 9415, factor: 0.94 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 19', unit: 1345, price: 9415, factor: 0.95 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 20', unit: 1345, price: 9415, factor: 0.96 },
        { name: 'อาคารศรีสวรินทิรานุสรณ์ 150 ปี FL. 21', unit: 1345, price: 9415, factor: 0.97 },
        { divider: true },
        { header: 'อาคาร 100 ปี' },
        { name: 'อาคาร 100 ปี FL. 1', unit: 1000, price: 7000, factor: 0.89 },
        { name: 'อาคาร 100 ปี FL. 2', unit: 1440, price: 10080, factor: 0.97 },
        { name: 'อาคาร 100 ปี FL. 3', unit: 2390, price: 16730, factor: 0.99 },
        { name: 'อาคาร 100 ปี FL. 4', unit: 1203, price: 8521, factor: 0.98 },
        { name: 'อาคาร 100 ปี FL. 5', unit: 493, price: 3451, factor: 0.89 },
        { name: 'อาคาร 100 ปี FL. 6', unit: 1345, price: 9415, factor: 0.93 },
        { name: 'อาคาร 100 ปี FL. 7', unit: 1345, price: 9415, factor: 0.94 },
      ],
      option: {
        tooltip: {
          position: 'top'
        },
        grid: {
          height: '50%',
          top: '10%'
        },
        xAxis: {
          type: 'category',
          data: hours,
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: 'category',
          data: days,
          splitArea: {
            show: true
          }
        },
        visualMap: {
          min: 0,
          max: 300,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '15%'
        },
        series: [
          {
            name: 'kwh',
            type: 'heatmap',
            label: {
              show: true
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.chart);
    const resizeObserver = new ResizeObserver((entries) => {
            this.myChart.resize();
    });
    resizeObserver.observe(this.$refs.chart);
    this.getEnergy()
  },
}
</script>